import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Launchoperatereal() {
  return (
    <section className="launch_operate_real p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Launch, Operate, and Expand Your <span>Real Estate Business</span>{" "}
              with Our Comprehensive Tech Solutions!
            </h2>
            <p>
              Being a leading real estate app development company, we create a
              flawless platform for users, builders, and brokers to locate and
              market properties using our innovative real estate app development
              services.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-4"
          >
            <StaticImage
              src="../../../images/solution/real-estate-updated/launch-operate.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1589}
              height={680}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Launchoperatereal;
